<template>
  <div>
    <div class="back">
        <el-button class="btn-back" @click.stop="onBack">返回</el-button>
    </div>
     <div class="module2Add_con detailsPage_con u-border">
      <!--表单项-->
      <div class="module2Add_form detailsPage_form">
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
            <el-form-item label="新闻标题:" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="新闻来源:" prop="source">
                <el-input v-model="form.source" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="新闻排序:" prop="indexing">
                <el-input v-model="form.indexing" style="width:100px"></el-input> &nbsp;&nbsp;
                <span>
                    (排序值越大，排名越靠前)
                </span>
            </el-form-item>
            <el-form-item label="新闻状态:" prop="status">
                <el-radio v-model="form.status" label="0">隐藏</el-radio>
                <el-radio v-model="form.status" label="1">显示</el-radio>
            </el-form-item>
            <el-form-item label="发布时间:" prop="publish_time">
                <el-col :span="6">
                    <el-date-picker
                    v-model="form.publish_time"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-col>
            </el-form-item>
            <div class="imgitem">
                <el-form-item   label="封面图片:" prop="cover_image">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadImgUrl"
                        :headers="{bearer: jwt}"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </div>
            <el-form-item label="新闻简介:" prop="introduce">
                <el-input type="textarea" v-model="form.introduce" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item label="新闻内容:" prop="content">
                <el-input v-model="form.content" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button>取消</el-button>
                <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
    import { addNews, getNewsDetail, putNews } from '@/api/apii';
    import { mapGetters } from 'vuex';

    export default {
        name: 'newsAdd',
        inject: ['myMessage', 'reload'],
        data () {
        return {
            form: {
                title: '',
                source: '',
                indexing: 0,
                status: '1',
                introduce: '',
                content: '',
                publish_time: '',
                cover_image: ''
            },
            rules: {
                title: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ],
                source: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ],
                indexing: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ],
                status: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ],
                introduce: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ],
                content: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ],
                publish_time: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ],
                cover_image: [
                    { required: true, message: '不能为空', trigger: ['change', 'blur'] }
                ]
            },
            imageUrl: '',
            id: '',
            type: ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'ai']
        };
        },
        computed: {
        ...mapGetters([
            'uploadImgUrl',
            'jwt'
        ])
        },
        methods: {
            handleAvatarSuccess (res, file) {
                this.imageUrl = res.dataset.data.url;
                this.form.cover_image = this.imageUrl;
            },
            beforeAvatarUpload (file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                let typeIsValidated = true;
                if (this.type.indexOf(file.type.split('/')[1]) < 0) {
                    typeIsValidated = false;
                }
                if (!typeIsValidated) {
                    this.myMessage.megError('图片只能是：' + this.type.join(',') + '格式');
                }
                if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                }
                return typeIsValidated && isLt2M;
            },
            onSubmit () {
                this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (this.id === '') {
                        this.requestAddNews();
                    } else {
                        this.updateNews();
                    }
                }
                });
            },
            requestAddNews () {
                addNews(this.handeleFormData())
                .then((res) => {
                    if (res.data != null) {
                        this.myMessage.megSuc('添加新闻成功');
                        const paths = this.$route.path.split('/');
                        paths.pop();
                        this.$router.push({ path: paths.join('/') });
                    }
                })
                .catch(() => {
                    this.myMessage.megError('新闻添加失败');
                });
            },
            updateNews () {
                putNews(this.handeleUpdateFormData())
                .then((res) => {
                    if (res.data !== null) {
                        this.myMessage.megSuc('编辑新闻成功');
                        const paths = this.$route.path.split('/');
                        paths.pop();
                        paths.pop();
                        this.$router.push({ path: paths.join('/') });
                    }
                })
                .catch(() => {
                    this.myMessage.megError('新闻编辑失败');
                });
            },
            handeleFormData () {
                const requestData = { ...this.form };
                requestData.indexing = requestData.indexing - 0;
                requestData.status = requestData.status - 0;
                requestData.cover_image = this.imageUrl;
                return requestData;
            },
            handeleUpdateFormData () {
                const requestData = { ...this.form };
                requestData.indexing = requestData.indexing - 0;
                requestData.status = requestData.status - 0;
                requestData.cover_image = this.imageUrl;
                return requestData;
            },
            onBack () {
                this.$router.back();
            },
            initForm (id) {
                getNewsDetail(id)
                    .then((res) => {
                        this.handleDetailsData(res.data);
                    })
                    .catch(() => {
                        this.myMessage.megError('获取详情信息失败');
                    });
            },
            handleDetailsData (data) {
                this.form = { ...data };
                this.form.status = this.form.status.toString();
                this.imageUrl = data.cover_image;
            }
        },
        created () {
            let id = this.$route.params.id;
            if (id !== undefined) {
                this.id = id;
                this.initForm(this.id);
            }
        }
    };
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    imgitem {
        vertical-align: middle;
    }
    .back {
        position: relative;
    }
    .btn-back {
        position: absolute;
        right: 30px;
        top: 20px;
    }
</style>
